export default __webpack_public_path__ + "static/media/yantralive-new-banner2.135a8806.png";